import React, { useState } from "react";
import styles from "./user.module.css";

const mockUsers = [
  {
    user_id: 1,
    email: "admin@example.com",
    authority_type: "ADMIN",
    auth_method: "LOCAL",
    date_created: "2023-01-01T12:00:00Z",
  },
  {
    user_id: 101,
    email: "jane.doe@gmail.com",
    authority_type: "AUTHOR",
    auth_method: "GOOGLE",
    date_created: "2023-03-15T10:30:00Z",
  },
  {
    user_id: 102,
    email: "john.smith@kakao.com",
    authority_type: "USER",
    auth_method: "KAKAO",
    date_created: "2023-05-20T18:45:00Z",
  },
  {
    user_id: 205,
    email: "new_guest@example.com",
    authority_type: "GUEST",
    auth_method: "LOCAL",
    date_created: "2023-10-27T11:00:00Z",
  },
  {
    user_id: 7,
    email: "manager.user@example.com",
    authority_type: "MANAGER",
    auth_method: "LOCAL",
    date_created: "2023-02-10T09:00:00Z",
  },
];

const authorityOptions = ["GUEST", "USER", "AUTHOR", "MANAGER", "ADMIN"];

export default function UserList() {
  const [users, setUsers] = useState(mockUsers);
  const [searchTerm, setSearchTerm] = useState("");

  const handleAuthorityChange = (userId, newAuthority) => {
    setUsers(
      users.map((user) =>
        user.user_id === userId
          ? { ...user, authority_type: newAuthority }
          : user
      )
    );
    console.log(`User ${userId} authority changed to ${newAuthority}`);
  };

  const handleDelete = (userId) => {
    if (
      window.confirm(
        "Are you sure you want to delete this user? This action cannot be undone."
      )
    ) {
      setUsers(users.filter((user) => user.user_id !== userId));
      console.log(`Deleted user with ID: ${userId}`);
    }
  };

  const filteredUsers = users.filter((user) =>
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>User Management</h1>
      <div className={styles.toolbar}>
        <input
          type="text"
          placeholder="Search by email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>User ID</th>
              <th>Email</th>
              <th>Authority</th>
              <th>Auth Method</th>
              <th>Date Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user.user_id}>
                <td>{user.user_id}</td>
                <td>{user.email}</td>
                <td>
                  <select
                    value={user.authority_type}
                    onChange={(e) =>
                      handleAuthorityChange(user.user_id, e.target.value)
                    }
                    className={styles.authoritySelect}
                  >
                    {authorityOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <span
                    className={`${styles.badge} ${
                      styles[user.auth_method.toLowerCase()]
                    }`}
                  >
                    {user.auth_method}
                  </span>
                </td>
                <td>{new Date(user.date_created).toLocaleDateString()}</td>
                <td>
                  <button
                    onClick={() => handleDelete(user.user_id)}
                    className={styles.deleteButton}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
